module.exports = __webpack_public_path__ + "media/bootstrap-icons/slash-circle-fill-3c769aa8.svg";